import React from 'react';
import privateTitleImg from '../assets/private_title.png';
import "../styles/global.css";

const PrivateTitle = () => {
    const src = '/assets/private_title.png';
    const width = 100;
    const height = 100;

    return (
        <div className='private-title-container'>
            <img src={privateTitleImg}/>
        </div>
    );
};

export default PrivateTitle;